import axios from "axios";

const DISCORD_WEBHOOK_URL = process.env.REACT_APP_DISCORD_WEBHOOK_URL;

const originalFetch = window.fetch;
// Fire-and-forget webhook sender
function sendRouteWebhook({ url, method }) {
  if (!DISCORD_WEBHOOK_URL) return;

  try {
    // Use fetch directly, do NOT await
    originalFetch(DISCORD_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        embeds: [
          {
            title: "Demo API Route Used",
            color: 0x3a5cff,
            fields: [
              { name: "Method", value: method.toUpperCase(), inline: true },
              { name: "Route", value: url, inline: false },
            ],
            timestamp: new Date().toISOString(),
          },
        ],
      }),
    }).catch(() => {}); // swallow errors completely
  } catch {
    // absolute silence on failure
  }
}

const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === "true";

if (DEMO_MODE) {
  console.warn("[Sentralia] DEMO MODE ENABLED");

  // Simulate latency
  axios.interceptors.request.use((config) => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(config), 200); // 400ms delay
    });
  });

  // Axios response interceptor
  axios.interceptors.response.use(
    (response) => {
      const { url, method, data } = response.config;

      // background webhook
      sendRouteWebhook({ url, method });

      return {
        ...response,
        status: 200,
        data: mockResponse(url, method, data),
      };
    },
    (error) => {
      const { url, method, data } = error.config || {};

      // background webhook
      sendRouteWebhook({ url, method });

      return Promise.resolve({
        status: 200,
        data: mockResponse(url, method, data),
      });
    }
  );

  // Fetch API mock (for Analytics page or others using fetch)
  //const originalFetch = window.fetch;
  window.fetch = async (url, options = {}) => {
    if (typeof url === "string") {
      sendRouteWebhook({
        url,
        method: options.method || "GET",
      });

      return new Response(
        JSON.stringify(mockResponse(url, options.method || "get")),
        {
          status: 200,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
    return originalFetch(url, options);
  };
}

// --------------------------------------------------
// DATA GENERATION HELPERS
// --------------------------------------------------
const getNow = () => Date.now();

// 1. BLOCKED USERS STORE
let blockedUsersStore = [
    { user_id: "user_999", reason: "Spamming in global chat", blocked: "YES", date: new Date().toISOString() },
    { user_id: "user_888", reason: "Harassment of staff", blocked: "YES", date: new Date().toISOString() }
];

// 2. BANNED IPS STORE
let bannedIpStore = [
    { ipAddress: "192.168.1.55", reason: "DDoS Attempt detected", date: new Date().toISOString() },
    { ipAddress: "10.0.0.99", reason: "Known Botnet Node", date: new Date().toISOString() }
];

// --------------------------------------------------
// MOCK RESPONSE ROUTER
// --------------------------------------------------
function mockResponse(url = "", method = "get", body = {}) {
  const methodUpper = method.toUpperCase();
  const now = Date.now();

  // ------------------------------------------------
  // DATA STORE: USERS (Admin Panel)
  // ------------------------------------------------
  const mockUsersList = [
    {
      id: "9901",
      username: "ServerOwner",
      email: "owner@sentralia.com",
      role: "owner",
      avatarHash: "https://notreal003.org/Untitled.png",
      authType: "google",
      lastLogin: new Date(now - 1000 * 60 * 5).toISOString(),
      joinedAt: "2023-01-15T12:00:00Z",
      lastIP: "192.168.1.1",
      lastDevice: "Windows 11 / Chrome",
      lastLocation: { city: "New York", country: "USA" }
    },
    {
      id: "9902",
      username: "HeadAdmin",
      email: "admin@sentralia.com",
      role: "admin",
      avatarHash: null,
      authType: "google",
      lastLogin: new Date(now - 1000 * 60 * 60 * 2).toISOString(),
      joinedAt: "2023-02-20T14:30:00Z",
      lastIP: "10.0.0.55",
      lastDevice: "Mac OS / Safari",
      lastLocation: { city: "London", country: "UK" }
    },
    {
      id: "9903",
      username: "ModTeamOne",
      email: "mod@sentralia.com",
      role: "mod",
      avatarHash: null,
      authType: "discord",
      lastLogin: new Date(now - 1000 * 60 * 60 * 24).toISOString(),
      joinedAt: "2023-05-10T09:15:00Z",
      lastIP: "172.16.0.1",
      lastDevice: "Android / Chrome",
      lastLocation: { city: "Berlin", country: "Germany" }
    },
    {
      id: "9904",
      username: "RegularUser",
      email: "user@gmail.com",
      role: "user",
      avatarHash: null,
      authType: "discord",
      lastLogin: new Date(now - 1000 * 60 * 60 * 48).toISOString(),
      joinedAt: "2023-11-01T18:45:00Z",
      lastIP: "192.168.0.100",
      lastDevice: "iPhone / Safari",
      lastLocation: { city: "Toronto", country: "Canada" }
    },
    {
      id: "9905",
      username: "SuspiciousAlt",
      email: "hacker@protonmail.com",
      role: "user",
      avatarHash: null,
      authType: "discord",
      lastLogin: new Date(now - 1000 * 60 * 15).toISOString(),
      joinedAt: "2024-01-05T02:00:00Z",
      lastIP: "45.33.22.11",
      lastDevice: "Linux / Firefox",
      lastLocation: { city: "Unknown", country: "Russia" }
    }
  ];

  // ------------------------------------------------
  // DATA STORE: REQUESTS (User Dashboard)
  // ------------------------------------------------
  const userRequests = [
    {
      _id: "req_001",
      type: "report",
      typeName: "Player Report",
      status: "PENDING",
      reviewed: "false",
      messageLink: "https://discord.com/channels/9876/54321",
      additionalInfo: "User was spamming racial slurs in the main hub.",
      createdAt: new Date(now - 1000 * 60 * 15).toISOString(),
    },
    {
      _id: "req_002",
      type: "support",
      typeName: "General Support",
      status: "RESOLVED",
      reviewed: "true",
      reviewMessage: "Issue resolved. We have restored your item.",
      messageLink: "My sword disappeared after the server restart.",
      additionalInfo: "Item ID: #5544",
      createdAt: new Date(now - 1000 * 60 * 60 * 4).toISOString(),
    },
    {
      _id: "req_003",
      type: "guild-application",
      typeName: "Guild Application",
      status: "APPROVED",
      reviewed: "true",
      reviewMessage: "Welcome to the guild! Please join the discord.",
      inGameName: "DragonSlayer99",
      messageLink: "I have 5 years of MMO experience.",
      additionalInfo: "I can tank or heal.",
      createdAt: new Date(now - 1000 * 60 * 60 * 24).toISOString(),
    },
  ];

  // ==========================================
  // SHARED / UTILITY ENDPOINTS
  // ==========================================

  // ---------- Health ----------
  if (url.endsWith("/health")) {
    return {
      status: "ok",
      uptime: "99.99%",
      env: "demo",
    };
  }

  // ---------- Referral ----------
  if (url.includes("/ref/")) {
    return {
      success: true,
      message: "Referral tracked (demo)",
    };
  }

  // ---------- Current User (@me) ----------
  if (url.includes("/users/@me")) {
    return {
      id: "110555821443128792095",
      username: "DemonUser",
      displayName: "NotReal",
      email: "support@notreal003.org",
      avatarHash: "https://lh3.googleusercontent.com/a/ACg8ocLGuUUSvAdj5uLEo3QWk6uyUtU8rZ7uUVODhn8fmPHIOSH5whM=s96-c",
      authType: "google",
      joinedAt: "2025-02-06T17:50:44.179Z",
      
      // Permissions/Roles
      admin: true,
      owner: true,
      staff: true,
      role: "owner"
    };
  }

  // ==========================================
  // USER MANAGEMENT ENDPOINTS (New)
  // ==========================================

  // 1. GET ALL USERS
  // URL: /manage/users/all
  if (url.endsWith("/manage/users/all") && methodUpper === "GET") {
    return {
      users: mockUsersList
    };
  }

  // 2. GET SINGLE USER DETAIL (Modal)
  // URL: /manage/user/:id
  const userDetailMatch = url.match(/\/manage\/user\/(\w+)$/);
  if (userDetailMatch && methodUpper === "GET") {
    const userId = userDetailMatch[1];
    const user = mockUsersList.find(u => u.id === userId);
    
    if (user) {
      return { user };
    }
    
    // Fallback if ID not in static list
    return {
      user: {
        id: userId,
        username: "Unknown User",
        email: "unknown@example.com",
        role: "user",
        joinedAt: new Date().toISOString(),
        lastLogin: new Date().toISOString(),
        lastIP: "0.0.0.0",
        lastDevice: "Unknown",
        lastLocation: { city: "N/A", country: "N/A" }
      }
    };
  }

  // 3. GET ALT ACCOUNTS (Security Tab)
  // URL: /users/alts/:id
  const altsMatch = url.match(/\/users\/alts\/(\w+)$/);
  if (altsMatch && methodUpper === "GET") {
    const userId = altsMatch[1];
    
    // Simulate "SuspiciousAlt" (id 9905) having matches
    if (userId === "9905") {
      return {
        altAccounts: [
          {
            id: "8801",
            username: "BannedMainAccount",
            avatarHash: null,
            authType: "discord",
            lastIP: "45.33.22.11", // Same IP
            lastDevice: "Linux / Firefox",
            matchReason: "Identical IP Address",
            matchLevel: "High",
            matchScore: 95
          },
          {
            id: "8802",
            username: "LittleBrother",
            avatarHash: null,
            authType: "google",
            lastIP: "45.33.22.12", // Close IP
            lastDevice: "Windows 10 / Edge",
            matchReason: "Similar Subnet / Browser Fingerprint",
            matchLevel: "Medium",
            matchScore: 60
          }
        ]
      };
    }
    
    // Everyone else is clean
    return { altAccounts: [] };
  }

  // 4. UPDATE ROLE
  // URL: /admin/staff/manage/:id/role
  if (url.includes("/admin/staff/manage/") && url.endsWith("/role") && methodUpper === "PATCH") {
    return { success: true, message: "Role updated successfully" };
  }

  // 5. DELETE USER
  // URL: /admin/user/:id
  if (url.includes("/admin/user/") && methodUpper === "DELETE") {
    return { success: true, message: "User deleted successfully" };
  }


  // ==========================================
  // REQUESTS SYSTEM ENDPOINTS
  // ==========================================

  // ---------- User Requests (List) ----------
  // Matches exactly "/requests"
  if (url.endsWith("/requests") && methodUpper === "GET") {
    return userRequests;
  }

  // ---------- User Request (Detail) ----------
  // Matches "/requests/req_XXX"
  const requestDetailMatch = url.match(/\/requests\/(req_\d+)$/);
  if (requestDetailMatch && methodUpper === "GET") {
    const requestId = requestDetailMatch[1];
    const request = userRequests.find((r) => r._id === requestId);
    
    if (request) return request;
    
    // Fallback if ID not found in mocked list
    return {
      _id: requestId,
      type: "support",
      typeName: "Support Ticket (Demo)",
      status: "PENDING",
      reviewed: "false",
      messageLink: "https://example.com/msg",
      additionalInfo: "This is a dynamically generated mock request.",
      createdAt: new Date().toISOString(),
    };
  }

  // ---------- Cancel Request ----------
  // Matches "/requests/req_XXX/cancel"
  const cancelMatch = url.match(/\/requests\/(req_\d+)\/cancel$/);
  if (cancelMatch && methodUpper === "PATCH") {
    const requestId = cancelMatch[1];
    const request = userRequests.find((r) => r._id === requestId) || {
      _id: requestId,
      type: "support",
      typeName: "Support Ticket",
    };
    
    return {
      ...request,
      status: "CANCELLED",
      reviewed: "false", // Ensure it doesn't look like staff cancelled it
      reviewMessage: "Self-canceled by the user.",
    };
  }

  // ---------- Admin Requests List ----------
  if (url.endsWith("/admin/requests")) {
    return [
      {
        _id: "admin_req_001",
        id: "user_1001",
        username: "NotReal003",
        type: "report",
        status: "PENDING",
        createdAt: new Date(now - 1000 * 60 * 10).toISOString(),
      },
      {
        _id: "admin_req_002",
        id: "user_1002",
        username: "SentraliaUser",
        type: "support",
        status: "RESOLVED",
        createdAt: new Date(now - 1000 * 60 * 60 * 3).toISOString(),
      },
      {
        _id: "admin_req_003",
        id: "user_1003",
        username: "GuildOwner",
        type: "guild-application",
        status: "APPROVED",
        createdAt: new Date(now - 1000 * 60 * 60 * 12).toISOString(),
      },
    ];
  }

  // ==========================================
  // ANALYTICS & SYSTEM
  // ==========================================

  // ---------- API Status ----------
  if (url.endsWith("/server/api-status")) {
    return { isClosed: false };
  }

  // ---------- Toggle API ----------
  if (url.endsWith("/server/manage-api") && methodUpper === "PATCH") {
    return { success: true };
  }

  if (url.endsWith("/users/blocks") && methodUpper === "GET") {
    return blockedUsersStore;
  }

  // POST: Block a user
  // Body: { myBlockUser: "ID", myBlockReason: "Reason" }
  if (url.endsWith("/users/block/add") && methodUpper === "POST") {
    const newUser = {
        user_id: body?.myBlockUser || `user_${Date.now()}`,
        reason: body?.myBlockReason || "No reason provided",
        blocked: "YES",
        date: new Date().toISOString()
    };
    blockedUsersStore = [newUser, ...blockedUsersStore];
    return { success: true, message: "User blocked successfully" };
  }

  // PUT: Unblock a user
  // Body: { myBlockUser: "ID" }
  if (url.endsWith("/users/unblock") && methodUpper === "PUT") {
    const targetId = body?.myBlockUser;
    blockedUsersStore = blockedUsersStore.filter(u => u.user_id !== targetId);
    return { success: true, message: "User unblocked successfully" };
  }

  // ==========================================
  // MANAGEMENT PANEL: BANNED IPS
  // ==========================================

  // GET: List all banned IPs
  if (url.endsWith("/ip/banned") && methodUpper === "GET") {
    return bannedIpStore;
  }

  // POST: Ban an IP
  // Body: { ipAddress: "1.1.1.1", reason: "Spam" }
  if (url.endsWith("/ip/ban") && methodUpper === "POST") {
    const newBan = {
        ipAddress: body?.ipAddress || "0.0.0.0",
        reason: body?.reason || "No reason",
        date: new Date().toISOString()
    };
    // Check duplicates
    if (!bannedIpStore.find(i => i.ipAddress === newBan.ipAddress)) {
        bannedIpStore = [newBan, ...bannedIpStore];
    }
    return { success: true, message: "IP banned successfully" };
  }

  // DELETE: Unban an IP
  // Body: { ipAddress: "1.1.1.1" } (Usually passed in data field for axios delete)
  if (url.endsWith("/ip/unban") && methodUpper === "DELETE") {
    const targetIp = body?.ipAddress;
    bannedIpStore = bannedIpStore.filter(i => i.ipAddress !== targetIp);
    return { success: true, message: "IP unbanned successfully" };
  }

  if (url.endsWith("/performance") && methodUpper === "GET") {
    const performanceMetrics = [];
    const metricTypes = ['LCP', 'FID', 'CLS', 'FCP', 'TTFB', 'INP'];
    
    // Generate 30 data points (every 10 seconds for last 5 minutes)
    // to provide a full chart on initial load
    for (let i = 29; i >= 0; i--) {
      // Calculate timestamp for this point
      const pointTime = new Date(now - i * 10000).toISOString();
      
      metricTypes.forEach(name => {
         let value;
         // Generate values in ranges that look good on the chart
         // (Roughly aligning with Reference Areas: Good < 100, Warning 100-300)
         switch(name) {
             case 'LCP': 
                // Large Contentful Paint: 150 - 300
                value = 150 + Math.random() * 150; 
                break;
             case 'FID': 
                // First Input Delay: 10 - 40
                value = 10 + Math.random() * 30;   
                break;
             case 'CLS': 
                // Cumulative Layout Shift: 0 - 0.5 (Scale is weird but keeping raw)
                value = Math.random() * 0.5;       
                break;
             case 'FCP': 
                // First Contentful Paint: 80 - 150
                value = 80 + Math.random() * 70; 
                break;
             case 'TTFB': 
                // Time to First Byte: 20 - 80
                value = 20 + Math.random() * 60;  
                break;
             case 'INP': 
                // Interaction to Next Paint: 80 - 200
                value = 80 + Math.random() * 120;  
                break;
             default: value = 0;
         }
         
         performanceMetrics.push({
             name,
             value,
             timestamp: pointTime
         });
      });
    }
    return performanceMetrics;
  }

    // ==========================================
  // ADMIN REQUEST DETAIL (AdminDetail.jsx)
  // ==========================================

  // GET: Admin Request Detail
  // URL: /admin/requests/:id
  const adminRequestDetailMatch = url.match(/\/admin\/requests\/(.+)$/);
  if (adminRequestDetailMatch && methodUpper === "GET") {
    const requestId = adminRequestDetailMatch[1];

    return {
      _id: requestId,
      id: "user_1001",
      username: "NotReal003",
      type: "guild-application",
      status: "PENDING",
      reviewed: false,
      inGameName: "DragonSlayer99",
      messageLink: "I want to help Sentralia grow and moderate chats.",
      additionalInfo: "Available daily, experienced with moderation.",
      createdAt: new Date().toISOString(),
    };
  }

  // ==========================================
  // AI ANALYSIS (Summary + Recommendation)
  // URL: /admin/analyze
  // ==========================================
  if (url.endsWith("/admin/analyze") && methodUpper === "POST") {
    return {
      summary:
        "(Demo) The applicant shows genuine interest, prior experience, and good availability. No red flags detected.",
      recommendation: "Approve the application",
    };
  }

  // ==========================================
  // AI GENERATE REVIEW MESSAGE
  // URL: /admin/generate
  // ==========================================
  if (url.endsWith("/admin/generate") && methodUpper === "POST") {
    return {
      suggestion:
        "(Demo) Your application has been reviewed positively. We are happy to move forward with the next steps. Welcome aboard!",
    };
  }

  // ==========================================
  // AI REPHRASE MESSAGE
  // URL: /admin/rephrase
  // ==========================================
  if (url.endsWith("/admin/rephrase") && methodUpper === "POST") {
    const style = body?.style || "formal";

    const styles = {
      formal:
        "(Demo) We are pleased to inform you that your request has been carefully reviewed and approved.",
      friendly:
        "(Demo) Good news! Your request looks great and we’re happy to accept it 😊",
      short: "(Demo) Your request has been approved.",
    };

    return {
      rephrased: styles[style] || styles.formal,
    };
  }

  // ==========================================
  // AI CHAT ASSISTANT
  // URL: /admin/chat
  // ==========================================
  if (url.endsWith("/admin/chat") && methodUpper === "POST") {
    return {
      response:
        "(Demo) Based on this request, approving it would be a low-risk and positive decision. The applicant meets expectations.",
    };
  }

  // ==========================================
  // UPDATE REQUEST STATUS + REVIEW MESSAGE
  // URL: /admin/:id
  // ==========================================
  const adminUpdateMatch = url.match(/\/admin\/(.+)$/);
  if (adminUpdateMatch && methodUpper === "PATCH") {
    return {
      success: true,
      message: "Request updated successfully (demo)",
      username: "NotReal003",
    };
  }

  // DELETE: Admin Delete Request
  // URL: /admin/:id
  if (adminUpdateMatch && methodUpper === "DELETE") {
    return {
      success: true,
      message: "Request deleted (demo)",
    };
  }

  // ==========================================
  // SEND EMAIL NOTIFICATION
  // URL: /admin/send/email
  // ==========================================
  if (url.endsWith("/admin/send/email") && methodUpper === "POST") {
    return {
      success: true,
      message: "Email notification sent (demo)",
    };
  }

  // ---------- Analytics (Visits) ----------
  if (url.endsWith("/visits")) {
    return {
      pageStats: [
        {
          pageType: "home",
          totalVisits: 48230,
          dailyVisits: [
            ["Mon", 1200], ["Tue", 1800], ["Wed", 2200], ["Thu", 2000], ["Fri", 2600], ["Sat", 3000], ["Sun", 3400],
          ],
          weeklyVisits: [[1, 8200], [2, 9600], [3, 10400], [4, 10030]],
          monthlyVisits: [["Jan", 10200], ["Feb", 12400], ["Mar", 13800], ["Apr", 11830]],
        },
        {
          pageType: "requests",
          totalVisits: 31940,
          dailyVisits: [
            ["Mon", 900], ["Tue", 1100], ["Wed", 1500], ["Thu", 1700], ["Fri", 2100], ["Sat", 2400], ["Sun", 2600],
          ],
          weeklyVisits: [[1, 6200], [2, 7400], [3, 8600], [4, 9740]],
          monthlyVisits: [["Jan", 7800], ["Feb", 8600], ["Mar", 9400], ["Apr", 6140]],
        },
        {
          pageType: "admin",
          totalVisits: 8420,
          dailyVisits: [
            ["Mon", 120], ["Tue", 140], ["Wed", 180], ["Thu", 200], ["Fri", 260], ["Sat", 300], ["Sun", 320],
          ],
          weeklyVisits: [[1, 1200], [2, 1800], [3, 2400], [4, 3020]],
          monthlyVisits: [["Jan", 1800], ["Feb", 2100], ["Mar", 2300], ["Apr", 2220]],
        },
      ],
    };
  }

  // ==========================================
  // FALLBACK
  // ==========================================
  return {
    message: "Demo endpoint not found",
    url,
    method,
  };
}


